export default (): string => {
  const { hostname } = window.location;

  // Localhost
  if (hostname === "localhost") {
    return "https://ibgmanager.test";
  }

  // Staging
  if (hostname.endsWith("staging.ibgmanager.dk")) {
    return "https://old.staging.ibgmanager.dk";
  }

  return "https://old.ibgmanager.dk";
};
